// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stocklogistics', {
        url: '/stocklogistics',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/stocklogistics/stocklogistics.tpl.html',
        controller: 'MainStockLogisticsController as vm'
    });
}

// @ngInject
function MainStockLogisticsController() {
    var vm = this;
}

angular
    .module('main.stocklogistics', ['stocklogistics.api','stocklogistics.articletransfer','stocklogistics.orderingpoints', 'stocklogistics.masshandlingorderingpoints' , 'stocklogistics.eshopreplenishment', 'stocklogistics.orderingpoints.autoMonthMultiplierDialog'])
    .config(stateConfig)
    .controller('MainStockLogisticsController', MainStockLogisticsController);
